import { gql } from "@apollo/client";

export const InfrastructureSelectNodeList = gql`
    query InfrastructureSelectNodeList($filter: InstalledBaseNodeListFilter!, $search: SearchInput, $pagination: Pagination) {
        installedBaseNodeList(filter: $filter, search: $search) {
            total
            installedBaseNodes(pagination: $pagination) {
                id
                key
                title
                assetCount
                childrenNodeCount
                nodeType {
                    id
                    key
                    name
                }
                pathNodes {
                    id
                    title
                }
            }
        }
    }
`;
